class MFooter extends HTMLElement{constructor(){super(),this.init()}init(){const e=this.querySelector(".m-footer--accordion"),t=document.querySelector(".m-mobile-sticky-bar");e&&(MinimogTheme.config.mqlMobile&&(this.acc=new MinimogLibs.Accordion(e,{presetContentHeight:!0,onload:!0})),document.addEventListener("matchMobile",(()=>{this.acc=new MinimogLibs.Accordion(e,{presetContentHeight:!0,onload:!0})}))),t&&(document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`),document.addEventListener("matchMobile",(()=>{document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`)})),document.addEventListener("unmatchMobile",(()=>{document.documentElement.style.setProperty("--mobile-sticky-bar-height",`${t.offsetHeight}px`)})))}}customElements.define("m-footer",MFooter);


document.addEventListener("DOMContentLoaded", () => {
  const moveWhenReady = () => {
    const timer = document.querySelector('revhope-countdown-timer[id="5dbae9b2-c310-4bc7-a7b4-364ec5678765"]');
    const avadaWrapper = document.querySelector('.Avada-Bar__OuterWrapper.Avada-Bar__OuterWrapper-0eaC0zIkKoEyHOWccQJV');

    if (timer && avadaWrapper && timer.parentNode) {
      timer.parentNode.insertBefore(avadaWrapper, timer);
      observer.disconnect();
      clearTimeout(timeoutId);
      return true;
    }

    return false;
  };

  if (moveWhenReady()) return;

  const observer = new MutationObserver(() => moveWhenReady());
  observer.observe(document.body, { childList: true, subtree: true });

  const timeoutId = setTimeout(() => {
    observer.disconnect();
    console.warn("Observer stopped after 5s — elements not found.");
  }, 5000);
});
